<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="titularesResiduosNoPeligrosos"
	[displayWith]="displayTitularResiduosNoPeligrosos"
	[value]="selectedTitularResiduosNoPeligrosos"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
